import styled from 'styled-components/macro';
import { TicketTextRegular } from '../../common/fontElements';

export const SelectLabel = styled(TicketTextRegular)`
  margin: 0;
`;

export const SelectOuterHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.center ? 'center' : 'auto')};

  .Select-control {
    height: 23px !important;
    display: flex !important;
    line-height: 20px !important;
    align-items: center;
    border-color: rgb(166, 166, 166) !important;
    background-color: rgb(248, 248, 248) !important;
  }

  .Select-control:hover {
    border: 1px solid rgb(166, 166, 166) !important;
  }

  .Select-loading-zone {
    position: absolute;
    right: 29px;
    top: auto;
  }

  .Select-placeholder {
    line-height: 20px !important;
    color: black !important;
    height: 20px;
  }

  .Select-value {
    line-height: 20px !important;
  }

  .Select-value-label {
    line-height: 20px !important;
  }

  .Select-arrow {
    color: black !important;
    border-top-color: black !important;
  }

  .Select-arrow-zone {
    position: absolute;
    right: 3px;
  }

  .Select-clear-zone {
    position: absolute;
    right: 25px;
  }

  .Select-loading {
    margin-bottom: 2px;
  }
`;
